<template>
  <div :class="{ 'center-screen' : !isMobile }">
    <div class="container">
      <div class="auth-page">
        <div class="form">
          <div class="row">
            <div class="col col-12">
                <div class="content">
                  <h3 class="line-title">İki Aşamalı Doğrulama</h3>
                  <form class="auth-content" v-on:submit.prevent="g2faSend">
                      <div class="col">
                          <div class="inline-form">
                              <label>G2FA Kodu</label>
                              <input :type="isMobile ? 'tel' : 'number'"  v-model="code" autocomplete="off" required>
                          </div>
                      </div>
                      <div class="col">
                          <ButtonLoader class="primary" :loader="!canLogin" :text="'Giriş Yap'" >
                            <template name="icon">
                              <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
                            </template>
                          </ButtonLoader>
                      </div>
                  </form>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    name:'G2faLogin',
    data(){
      return{
        canLogin: true,
        code: null,
      }
    },
    methods:{
      g2faSend(){
        this.canLogin = false;
        axios.post('/auth/g2fa', { code : this.code })
          .then((response)=>{
              if(response.data.status){
                this.$store.dispatch('auth/token', response.data.data.token);
                this.$store.dispatch('auth/user');
                this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message });
              }
          })
          .catch((err)=>{
              
          })
          .finally((f) => { 
              this.code = null;
              this.canLogin = true;
          })
      },
    }
  }
</script>